
    const gaMeasurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;

    if (gaMeasurementId && gaMeasurementId.trim().length > 0 && gaMeasurementId !== 'YOUR_GA_MEASUREMENT_ID') {
        const gaScript = document.createElement('script');
        gaScript.async = true;
        gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${gaMeasurementId}`;
        document.head.appendChild(gaScript);

        window.dataLayer = window.dataLayer || [];
        function gtag(){window.dataLayer.push(arguments);}
        window.gtag = window.gtag || gtag;

        // Set default consent mode
        gtag('consent', 'default', {
            'analytics_storage': 'denied',
            'ad_storage': 'denied',
            'wait_for_update': 500,
        });

        gtag('js', new Date());
        gtag('config', gaMeasurementId, {
            page_title: 'Feedback | My Speed Tools',
            page_location: window.location.href
        });
    }
